module.exports = __webpack_public_path__ + "img/42.03e96822.jpg";